import { render, staticRenderFns } from "./AddComboNew.vue?vue&type=template&id=bb2cc982&scoped=true&"
import script from "./AddComboNew.vue?vue&type=script&lang=js&"
export * from "./AddComboNew.vue?vue&type=script&lang=js&"
import style0 from "./AddComboNew.vue?vue&type=style&index=0&id=bb2cc982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2cc982",
  null
  
)

export default component.exports